import { MainLayout } from 'shared/ui/layout/main';

import { Tabs } from '../tabs';

export function UsersGroupLayout() {
  return <MainLayout tabs={<Tabs />} />;
}
